import { FC } from 'react';

import { FormProvider } from 'react-hook-form';

import AddressFinder from '@components/AddressFinder/AddressFinder';
import RichText from '@components/RichText/RichText';
import { TrackedNotificationBox } from '@components/TrackedNotificationBox/TrackedNotificationBox';
import { WarmthCheckAddressFinderRendering } from '@sitecore/types/WarmthCheckAddressFinder';
import { Box, Button, Form } from '@sparky';

import useWarmChecker from './hooks/useWarmChecker';

const WarmChecker: FC<WarmthCheckAddressFinderRendering> = ({ fields: textualData }) => {
  const { formMethods, error, handleFormSubmit, isHouseNumberSuffixRequired, setIsHouseNumberSuffixRequired } =
    useWarmChecker(textualData);

  const { handleSubmit } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <Form onSubmit={handleSubmit(handleFormSubmit)}>
        <Box>
          <AddressFinder
            customLabels={{
              houseNumber: textualData?.address?.houseNumberFormField,
              postalCode: textualData?.address?.postalCodeFormField,
              houseNumberSuffix: textualData?.address?.houseNumberSuffixFormField,
            }}
            isSuffixRequired={isHouseNumberSuffixRequired}
            setIsSuffixRequired={setIsHouseNumberSuffixRequired}
          />
        </Box>

        {error && (
          <Box paddingTop="2">
            <TrackedNotificationBox
              emphasis="low"
              isAlert
              text={<RichText html={error.content || ''} />}
              title={error.title || ''}
              variant="error"
            />
          </Box>
        )}

        <Box paddingTop="6">
          <Button size="regular" type="submit">
            {textualData?.content?.buttonText?.value}
          </Button>
        </Box>
      </Form>
    </FormProvider>
  );
};

export default WarmChecker;
